import { Directive, input, OnInit } from '@angular/core';

import { fieldDescribedBy, MibFieldControl } from '../internal/field-control.utils';

/**
 * Shows the state of a native text field bound to a form: `mib-field-error` and `aria-invalid` once it
 * is touched or changed while invalid, `aria-required` when its control is required. Imported, it
 * applies to every `mib-input` and `mib-textarea` bound with `formControl`, `formControlName`, `ngModel` or `formField`.
 */
@Directive({
  selector:
    'input.mib-input[formControl], input.mib-input[formControlName], input.mib-input[ngModel], input.mib-input[formField], ' +
    'textarea.mib-textarea[formControl], textarea.mib-textarea[formControlName], textarea.mib-textarea[ngModel], ' +
    'textarea.mib-textarea[formField]',
  host: {
    '[class.mib-field-error]': 'control.showsError()',
    '[attr.aria-invalid]': 'control.showsError() ? "true" : null',
    '[attr.aria-required]': 'control.required() ? "true" : null',
    '[attr.aria-describedby]': 'describedBy()',
  },
})
export class MibFieldDirective implements OnInit {
  /** The id of the error or help message read with the field, added to any `aria-describedby` already set. */
  readonly mibFieldDescribedBy = input<string | null>(null);

  protected readonly control = new MibFieldControl();

  protected readonly describedBy = fieldDescribedBy(this.mibFieldDescribedBy);

  ngOnInit(): void {
    this.control.connect();
  }
}
